import React from 'react';
import { theme } from '../../design/theme';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing.xl,
      padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
      borderBottom: `2px solid ${theme.colors.brand.main}`,
      backgroundColor: theme.colors.background.surface,
      borderRadius: '12px',
      boxShadow: theme.shadows.sm,
    }}>
      <div>
        <h1 style={{ 
          ...theme.typography.h1, 
          color: theme.colors.neutral[900], 
          margin: 0,
          fontSize: '32px',
          fontWeight: '700',
          letterSpacing: '-0.02em'
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ 
            ...theme.typography.body, 
            color: theme.colors.neutral[500], 
            marginTop: '4px', 
            marginBottom: 0,
            fontSize: '16px'
          }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: theme.spacing.md }}>
          {actions}
        </div>
      )}
    </div>
  );
};
